import React from 'react';
export function CO2DisadvantagesSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-6" data-id="element-1506">
      <h2 className="text-2xl md:text-3xl font-bold text-navy border-b border-gray-200 pb-4" data-id="element-1507">
        Disadvantages of CO2 lasers
      </h2>
      <div className="space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-1508">
        <p data-id="element-1509">
          The main disadvantages of CO2 lasers are where the advantages of fiber
          lasers lie. Firstly, CO2 lasers are sensitive machines that require
          alignment, so should this get knocked out of place, usually an expert
          is required to fix it, resulting in long periods of down time when the
          laser is not being productive.
        </p>
        <p data-id="element-1510">
          This also means they need more regular servicing, and the costs of
          this maintenance are higher. Alongside this, more power is needed,
          resulting in higher electrical costs. CO2 lasers are also slower at
          cutting thin materials, and aren't able to work with reflective metals
          (brass, aluminum etc) to a good degree.
        </p>
      </div>
    </div>;
}